module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.a1e573ee.svg";